module.exports = __webpack_public_path__ + "img/WBTC.4031ce47.svg";